import { put, call, select, delay, race } from 'redux-saga/effects'
import { createModal } from 'redux-saga-modal'
import {
  TOGGLE_SEARCH_DIALOG
} from './actionTypes'
// import { getSessionList } from './selectors'
import * as services from './services'
import * as actions from './actions'
import { message } from 'antd'

export default {
  *[TOGGLE_SEARCH_DIALOG]() {
    const modal = createModal('GLOBAL_SEARCH')

    yield modal.show()

    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })

    if (submit) {
      yield modal.hide()
    } else {
      yield modal.destroy()
    }
  },
}
